var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { CardContent, useTheme } from "@mui/material";
import { CardFooter, CardOverImageTitle, CardWithShadow } from "../components";
import useIosContext from "@nitra/nkmb-card-components/contexts/IosContextProvider";
export var LargeImageCard = function (props) {
    var _a;
    var title = props.title, imageUrl = props.imageUrl, createdAt = props.createdAt, onClickSpecialAction = props.onClickSpecialAction, to = props.to, hideTitle = props.hideTitle;
    var PLACEHOLDER = "/images/placeholder600x360.png";
    var _b = useState("url(".concat(imageUrl, "), url(").concat(PLACEHOLDER, ")")), backgroundUrl = _b[0], setBackgroundUrl = _b[1];
    var isIos = useIosContext().isIos;
    var theme = useTheme();
    useEffect(function () {
        setBackgroundUrl("url(".concat(imageUrl, "), url(").concat(PLACEHOLDER, ")"));
    }, [imageUrl]);
    return (_jsxs(CardWithShadow, __assign({ sx: { display: "flex", flexDirection: "column", position: "relative" }, onClickSpecialAction: onClickSpecialAction, to: to, fullSizeImageUrl: backgroundUrl, fixedWidth: 600 }, { children: [!hideTitle &&
                _jsx(CardContent, __assign({ sx: { mt: "auto", zIndex: 1, pb: 0 } }, { children: _jsx(CardOverImageTitle, { localizedTitle: title, variant: "h3", sx: (_a = {},
                            _a[theme.breakpoints.down("sm")] = isIos && {
                                '@media (-webkit-min-device-pixel-ratio: 2)': {
                                    fontWeight: 500, // Adjust font weight for iPhones
                                },
                            },
                            _a) }) })), !hideTitle && !!createdAt && _jsx(CardFooter, { brightText: true, createdAt: createdAt, shareUrl: to })] })));
};
